import React from 'react';
import Styles from './module-current-item-styles.scss';
import classNames from 'classnames';
import { CirclePlayButton, ProgressBarSimple } from '@/presentation/components';
const ModuleCurrentItem = ({ title = 'ModuleCurrentItem', backgroundColor = 'blue', type = 'blocked', icon: Icon, module, onClick }) => {
    function parsePercent(num) {
        try {
            if (num === 100)
                return num.toFixed(1);
            return num.toFixed(2);
        }
        catch (error) {
            return num;
        }
    }
    return (React.createElement("div", { className: classNames([Styles.moduleItemWrap, Styles[backgroundColor]]) },
        React.createElement("div", { className: Styles.score },
            React.createElement("div", { className: Styles.scoreContent }, Icon && React.createElement("div", { className: Styles.logo }, Icon))),
        React.createElement("div", { className: Styles.subTitle }, module.moduleTitle),
        React.createElement("div", { className: Styles.title }, module.title),
        React.createElement("div", { className: Styles.content },
            React.createElement("p", { className: Styles.description }, module.description),
            React.createElement("div", { className: Styles.progressContainer },
                React.createElement("div", { className: Styles.bar },
                    React.createElement(ProgressBarSimple, { backgroundColor: "white", pointColor: backgroundColor, leftText: "Progress", rightText: `${parsePercent(module.progress)}%`, percentage: parsePercent(module.progress) })),
                React.createElement("div", { className: Styles.icon },
                    React.createElement(CirclePlayButton, { onClick: onClick, background: "white" }))))));
};
export default ModuleCurrentItem;
